'use strict'

import angular from 'angular';

angular.module('activityLog.services', [])
    .factory('ActivityLogService', ActivityLogService)
    .factory('ActivityLogFactory', ActivityLogFactory)

/**
 * @ngInject
 */
function ActivityLogService(ActivityLogFactory) {
    let resource = ActivityLogFactory.activityLog()
    return {
        getAllActivityLogs(afterCreatedAt) {
            if (afterCreatedAt) {
                return resource.index({afterCreatedAt: afterCreatedAt}).$promise
            }

            return resource.index().$promise
        },
        getAllActivityLogsAugmentedAfter(afterCreatedAt) {
            return resource.augmentedAfter({afterCreatedAt: afterCreatedAt}).$promise
        }
    }
}

/**
 * @ngInject
 */
function ActivityLogFactory($resource, AppConfig) {
    return {
        activityLog() {
            let url = AppConfig.IO_API_URL + 'activityLogs'
            return $resource(url, null, {
                index: {
                    method: 'GET',
                    isArray: false,
                    url: url
                },
                augmentedAfter: {
                    method: 'GET',
                    isArray: false,
                    url: url + '/augmentedAfter'
                }
            })
        }
    };
}